module.exports = __webpack_public_path__ + "static/media/keyframe_960x530.1136eb64.jpg";